import { render, staticRenderFns } from "./JGspecialTestDetail.vue?vue&type=template&id=01308cbb"
import script from "./JGspecialTestDetail.vue?vue&type=script&lang=js"
export * from "./JGspecialTestDetail.vue?vue&type=script&lang=js"
import style0 from "./JGspecialTestDetail.vue?vue&type=style&index=0&id=01308cbb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports